module.exports = __webpack_public_path__ + "static/media/grand-master.bca7454e.svg";